<template>
  <popup class="settings-popup">
    <div class="set-wrap wrap-common rel">
      <p class="close-btn btn-common" @click="handleClose">
        <i class="icon-close-line iconfont"></i>
      </p>
      <div class="item-block">
        <p class="setting-title tc">Theme Setting</p>
        <ul class="item">
          <li>
            <label>Background Color</label>
            <p class="set-input primary" :class="{'error-border': validation.hasError('primaryColor')}">
              <input class="color-input" type="text"
                     :style="primaryStyle"
                     v-model="primaryColor"/>
              <i @click="handleOpen('primaryColor')"
                 class="iconfont icon-Layer-182"></i>
              <slider-picker v-if="picker.primaryColor"
                             :swatches="swatches"
                             :value="primaryColor"
                             @input="handleColorUpdate('primaryColor', $event)" />
            </p>
            <p class="error">{{ validation.firstError('primaryColor') }}</p>
          </li>
          <li>
            <label>Text Color</label>
            <p class="set-input text" :class="{'error-border': validation.hasError('textColor')}">
              <input class="color-input" type="text"
                     :style="textStyle"
                     v-model="textColor"/>
              <i @click="handleOpen('textColor')"
                 class="iconfont icon-Layer-182"></i>
              <slider-picker v-if="picker.textColor"
                             :value="textColor"
                             :swatches="swatches"
                             @input="handleColorUpdate('textColor', $event)"/>
            </p>
            <p class="error">{{ validation.firstError('textColor') }}</p>
          </li>
          <li>
            <label>Block Color</label>
            <p class="set-input accent" :class="{'error-border': validation.hasError('accentColor')}">
              <input class="color-input" type="text"
                     :style="accentStyle"
                     v-model="accentColor"/>
              <i @click="handleOpen('accentColor')"
                 class="iconfont icon-Layer-182"></i>
              <slider-picker v-if="picker.accentColor"
                             :value="accentColor"
                             :swatches="swatches"
                             @input="handleColorUpdate('accentColor', $event)"/>
            </p>
            <p class="error">{{ validation.firstError('accentColor') }}</p>
          </li>
        </ul>

        <div class="btn theme-btn setting-btn" @click="handleColorSave">Save</div>
      </div>

      <upload-vcf @update="handleVCFUpdate"></upload-vcf>

      <div class="item-block">
        <p class="setting-title tc">Reset Password</p>
        <div class="reset-btn setting-btn btn" @click="handleReset">Reset password</div>
      </div>

    </div>
  </popup>
</template>

<script>
import loading from "../../common/utils/loading";
import adminService from '../service/adminService';
import Slider from 'vue-color/src/components/Slider.vue'
import popup from "./popup.vue";
import upload from "./upload-vcf.vue";
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

const DEFAULT_SATURATION = 0.5

export default {
  components: {
    'slider-picker': Slider,
    popup,
    "upload-vcf": upload,
  },
  data() {
    return {
      close: true,
      settingColor: {},
      primaryColor: '#FFFFFF',
      textColor: '#000000',
      accentColor: '#FEB727',

      picker: {
        primaryColor: false,
        textColor: false,
        accentColor: false,
      },

      swatches: [
        { s: DEFAULT_SATURATION, l: 1 },
        { s: DEFAULT_SATURATION, l: 0.8 },
        { s: DEFAULT_SATURATION, l: 0.65 },
        { s: DEFAULT_SATURATION, l: 0.5 },
        { s: DEFAULT_SATURATION, l: 0.35 },
        { s: DEFAULT_SATURATION, l: 0.2 },
        { s: DEFAULT_SATURATION, l: 0 },
      ],
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    primaryStyle() {
      return {
        backgroundColor: `${this.primaryColor}`,
      }
    },
    primaryPickerStyle() {
      return {
        backgroundColor: `${this.primaryColor}`,
      }
    },
    textStyle() {
      return {
        backgroundColor: `${this.textColor}`,
      }
    },
    textPickerStyle() {
      return {
        backgroundColor: `${this.textColor}`,
      }
    },
    accentStyle() {
      return {
        backgroundColor: `${this.accentColor}`,
      }
    },
    accentPickerStyle() {
      return {
        backgroundColor: `${this.accentColor}`,
      }
    },

  },

  methods: {
    handleOpen(key) {
      this.$set(this.picker, key, !!!(this.picker[key]));
    },
    handleColorSave() {
      this.$validate()
          .then((success)=> {
            if(success){
              loading.show();
              adminService.saveColor(this.primaryColor, this.textColor, this.accentColor)
                  .then(() => {
                    console.log("handleColorSave")
                    this.$emit("update", {
                      "primary_color" : this.primaryColor,
                      "text_color" : this.textColor,
                      "accent_color" : this.accentColor,
                    });
                    this.handleClose();
                  })
                  .catch(error => {
                    console.log(error);
                  })
                  .finally(() => {
                    loading.hide();
                    this.picker = {
                      primaryColor: false,
                      textColor: false,
                      accentColor: false,
                    }
                  });
            }
            return;
          });

    },

    handleColorUpdate(key, color) {
      this.$set(this.$data, key, color.hex);
    },

    handleClose() {
      this.$emit('close', this.close);
    },

    handleVCFUpdate() {
      this.handleClose();
      loading.hide();
      this.$emit("vcf");
    },

    handleReset(){
      loading.show();
      adminService.resetEmail();
      this.$router.push({
        path: "/reset-pwd-email"
      });
      loading.hide();
    }
  },

  mounted() {
    this.primaryColor = this.options.primaryColor || this.primaryColor;
    this.textColor = this.options.textColor || this.textColor;
    this.accentColor = this.options.accentColor || this.accentColor;
  },

  validators: {
    primaryColor: function(value) {
      return Validator.value(value).required().regex('^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$','Format does not match');
    },
    textColor: function(value) {
      return Validator.value(value).required().regex('^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$','Format does not match');
    },
    accentColor: function(value) {
      return Validator.value(value).required().regex('^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$','Format does not match');
    },


  },
}
</script>

